import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask2100To2199Service {

  constructor() { }
}
